class SubscriberArrTool {
  /**
   * 获取所有组
   * @param _json
   * @returns {any[]}
   */
  $getGroup(_json) {
    const _groupSet = new Set();
    _json.forEach((_item) => {
      if (_item.groupBy === undefined) {
        _groupSet.add('noGroup');
      } else {
        _groupSet.add(_item.groupBy);
      }
    });
    return Array.from(_groupSet);
  }

  /**
   * 根据UIINDEX排序数组
   * @param _json
   * @returns {*}
   */
  $devideByUiIndex(_json) {
    for (let i = 0; i < _json.length; i++) { // 冒泡
      for (let j = i + 1; j < _json.length; j++) {
        if (_json[i].uiIndex !== undefined && _json[j].uiIndex !== undefined && _json[i].uiIndex > _json[j].uiIndex) {
          const _tempItem = _json[i];
          _json[i] = _json[j];
          _json[j] = _tempItem;
        }
      }
    }
    return _json;
  }

  /**
   * 根据groupBy分组
   * @param _json
   * @returns {Map<any, any>}
   */
  $devideByGroupBy(_json, _data = []) {
    const _groupTemp = this.$getGroup(_json);
    const _mapByGroup = new Map();
    this.$initSelectControl(_json, _data);
    _json.forEach((_item) => {
      this.$initDatas(_item, _data); // 初始化设置值
    });
    _groupTemp.forEach((_groupItem) => {
      let _arr = [];
      _json.forEach((_item) => {
        // _item = this.$initDatas(_item, _data); // 初始化设置值
        if (_item.groupBy === undefined && _groupItem === 'noGroup' && _item.type !== 'text[]') {
          _arr.push(_item);
        } else if (_item.groupBy === _groupItem && _item.type !== 'text[]') {
          _arr.push(_item);
        } else if (_item.groupBy === _groupItem && _item.type === 'text[]') {
          _arr = _item.attrList[1].attrList;
          return false; // textArray不支持多个字段所属一个groupBy, 如出现, 只识别第一个
        }
        return true;
      });
      if (_arr.length > 0) {
        _arr = this.$devideByUiIndex(_arr);
        _mapByGroup.set(_groupItem, _arr);
      }
    });
    return _mapByGroup;
  }

  $initDatas(_item, _paramsData) {
    if (_paramsData.length === 0) return _item;
    if (_paramsData instanceof Map) {
      if (_paramsData.get(_item.name) !== undefined) {
        _item.value = _paramsData.get(_item.name);
      }
      // type为text[] 类型时的额外判断, 将list返回值以数组的形式赋给某一模板字段, 待运用ParseList时, 再生成多组数据。
      if (_item.type === 'text[]' && _item.attrList !== undefined && _item.attrList[0].name === 'count' && _item.attrList[1].name === 'list' && _item.attrList[1].attrList !== undefined) {
        if (_paramsData.get(_item.name) === undefined) return true;
        const _listLength = _paramsData.get(_item.name).count;
        _item.attrList[1].attrList.forEach((_attrTemp) => {
          const _attrTempComb = [];
          let _index = 0;
          const _itemList = _paramsData.get(_item.name).list;
          while (_index < _listLength) {
            _attrTempComb.push(_itemList[_index][_attrTemp.name])
            _index++;
          }
          _attrTemp.valueList = _attrTempComb;
        });
      }
    } else {
      if (_paramsData[_item.name] !== undefined) {
        _item.value = _paramsData[_item.name];
      }
      // type为text[] 类型时的额外判断, 将list返回值以数组的形式赋给某一模板字段, 待运用ParseList时, 再生成多组数据。
      if (_item.type === 'text[]' && _item.attrList !== undefined && _item.attrList[0].name === 'count' && _item.attrList[1].name === 'list' && _item.attrList[1].attrList !== undefined) {
        if (_paramsData[_item.name] === undefined) return true;
        const _listLength = _paramsData[_item.name].count;
        _item.attrList[1].attrList.forEach((_attrTemp) => {
          const _attrTempComb = [];
          let _index = 0;
          const _itemList = _paramsData[_item.name].list;
          while (_index < _listLength) {
            _attrTempComb.push(_itemList[_index][_attrTemp.name])
            _index++;
          }
          _attrTemp.valueList = _attrTempComb;
        });
      }
    }
    return _item;
  }

  /**
   * 初始化控制字段显隐方法
   * @param _json
   * @param _data
   */
  $initSelectControl(_json, _data = []) {
    const _tempControl = [];
    _json.forEach((_item) => {
      if (_item.type === 'select' && _item.changeClick === true) {
        if (_item.options !== undefined) {
          try {
            if (_item !== undefined && _item.name !== undefined && _data[_item.name] !== undefined) {
              _item.value = _data[_item.name];
            }
          } catch (e) {
          }
          _item.options.forEach((_opItm) => {
            if (_opItm.value === _item.value) {
              _tempControl.push(_opItm.attr);
            }
          });
        }
      }
    });
    _tempControl.forEach((_temp) => {
      for (let i = 0; i < _json.length; i++) {
        _temp.forEach((_tItm) => {
          if (_tItm.name === _json[i].name) {
            _json[i] = _tItm;
          }
        });
      }
    });
  }
}
export default SubscriberArrTool;
